import { useReactiveVar } from '@apollo/client'
import { useMatch } from 'react-router-dom'
import { RestrictionEnum } from '../../../graphql/generated'
import { authenticatedUserVar } from '../../../providers/apollo/cache'

export default function useUserSettings() {
  const user = useReactiveVar(authenticatedUserVar)
  const subscription = user?.profile?.subscription
  const maxSpace = subscription?.plan.maxSpace
  const maxImagesCount = subscription?.plan.maxImagesCount
  const usedMediaSpace = subscription?.totalUserUsedSpace || 0
  const maxMediaSpace = !maxSpace || maxSpace === -1 ? Infinity : maxSpace
  const usedMediaCount = subscription?.totalImagesCount || 0
  const maxMediaCount = !maxImagesCount || maxImagesCount === -1 ? Infinity : maxImagesCount
  const overspace = usedMediaSpace >= maxMediaSpace
  const overcount = usedMediaCount >= maxMediaCount
  const isHostingLimited = !!subscription?.plan.hostingThreshold && !subscription?.plan.hostingThreshold.maxHostingThreshold
  const isAccountOverStorage = overspace || overcount
  const isFreeUser = subscription?.plan.title.toLowerCase() === 'free'
  const isSearchMatch = useMatch('/u/:userId/search')
  const isEmailVerified = user?.profile?.emailStatus === 'VALID'

  const restrictions: { [key in RestrictionEnum]?: boolean } = {}
  user?.profile?.subscription.restrictions?.forEach(({ key, value }) => {
    restrictions[key] = value
  })

  const userApplicationSettings = {
    defaultAlbum: user?.profile?.defaultAlbum,
    isAccountOverStorage,
    isBuyPrintsDisabled: isAccountOverStorage,
    isEditDisabled: isFreeUser || isAccountOverStorage || restrictions.IMAGE_EDITOR,
    isFavoriteDisabled: isAccountOverStorage || restrictions.FAVORITES,
    isFreeUser,
    isLimited: isHostingLimited || restrictions.HOSTING,
    isMediaTagsDisabled: restrictions.USER_TAGS,
    isMoveDisabled: !!isSearchMatch || isAccountOverStorage,
    isSearchDisabled: restrictions.SEARCH,
    isModifyAlbumsDisabled: restrictions.MODIFY_ALBUMS,
    isShareDisabled: isAccountOverStorage || restrictions.SHARING,
    isSlideShowDisabled: !!isSearchMatch,
    isSortDisabled: restrictions.SORT_BY_TITLE || restrictions.SORT_BY_UPLOAD_DATE,
    isUploadDisabled: !isEmailVerified || isAccountOverStorage || !!isSearchMatch,
    isDownloadDisabled: !isEmailVerified,
    isVideoPlayerDisabled: restrictions.VIDEO_PLAYER,
    linkBackOption: user?.profile?.albumsSettings?.linkBackOption,
    mobileAlbum: user?.profile?.mobileAlbum,
    username: user?.profile?.username
  }

  return userApplicationSettings
}
